import { defineStore } from 'pinia';
import { ref } from 'vue';

export type FieldPath = string;
export type FieldErrors = Record<FieldPath, string[]>;
type State = Record<string, FieldErrors>;

export const useValidationErrorsStore = defineStore('validationErrors', () => {
    const errors = ref<State>({});

    const setScopeErrors = (scope: string, fieldErrors: FieldErrors) => {
        if (Object.keys(fieldErrors).length === 0) {
            delete errors.value[scope];
            return;
        }
        errors.value[scope] = fieldErrors;
    };

    const clearScope = (scope: string) => {
        delete errors.value[scope];
    };

    const clearField = (scope: string, path: FieldPath) => {
        const scopeErrors = errors.value[scope];
        if (!scopeErrors) return;
        delete scopeErrors[path];
        if (Object.keys(scopeErrors).length === 0) {
            delete errors.value[scope];
        }
    };

    const clearAll = () => {
        errors.value = {};
    };

    return {
        errors,
        setScopeErrors,
        clearScope,
        clearField,
        clearAll,
    };
});
